import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { TipoRevisionService } from '../tipo-revision.service';

@Component({
  selector: 'app-tipo-revision-update',
  templateUrl: './tipo-revision-update.component.html',
  styleUrls: ['./tipo-revision-update.component.scss']
})
export class TipoRevisionUpdateComponent implements OnInit {

  @Input() element: any = null;
  form: FormGroup = new FormGroup({});

  constructor(
    private formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: TipoRevisionService,
    public formatter: FormatterService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      descripcion: [''],
    });

    this.form.patchValue(this.element)
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      this.service.update(this.form.value).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert("Actualización realizada con éxito.", "success");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el tipo.", "danger");
        }
      });
    } else {
      this.form.markAllAsTouched();
    }
  }
}
